import React from "react";
import styles from "./Home.module.scss";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

// Assets
import earth from "assets/images/lottie/earth.json";

// Components
import Navbar from "components/Shared/Navbar";

const Home = () => {
  return (
    <div className={styles.Home}>
      <Navbar />
      <div className={styles.main}>
        <div className={styles.content}>
          <div>
            <h1>
              Develop today <br />
              create tomorrow
            </h1>
            <div className={styles.welcoming}>
              Welcome to IEEE Kafrelsheikh SB
            </div>
            <p>
              The IEEE Kafrelsheikh Student Branch is the leading organization
              in Kafrelsheikh city that works to build, innovate and inspire the
              technical community
            </p>

            <Link to="/about">Know More</Link>
          </div>
        </div>
        <div className={styles.illustration}>
          <Lottie animationData={earth} loop={true} style={{ height: "calc(100vh - 275px)" }} />
        </div>
      </div>
    </div>
  );
};

export default Home;
